module.exports = __webpack_public_path__ + "static/media/img-manner-quietness.8712543a.svg";